module.exports = __webpack_public_path__ + "static/upperright_box-5710090b1483f75c5e39c40cda76cb21.png";